import { render } from "./CorrelationCoefficient.vue?vue&type=template&id=76077032"
import script from "./CorrelationCoefficient.vue?vue&type=script&lang=js"
export * from "./CorrelationCoefficient.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__